export type Permissions = Permission[];

export interface Permission {
    auth: string;
    status: PermissionStatus;
}

export enum PermissionStatus {
    NO_PERMISSION = 'NO_PERMISSION',
    GRANTED = 'GRANTED',
    REQUESTED = 'REQUESTED',
}
